import { Breadcrumb } from 'modules/model-json';

export const KITCHEN_PATH = '/proekt-kuhni/';

export const KITCHEN_SIGN_UP_HREF = '/zapis-onlayn/?department_no=15&region_id=';

export const KITCHEN_CALCULATOR_HREF = '/kalkulyator-remonta/raschet-stoimosti-kuhni/';

export const KITCHEN_ELEMENT_BLOCK = 'landingProektKuhni';

export const GUARANTEE_DOC =
  'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/kitchen/Delinia_guarantee.pdf';

export const MODIFIED_KITCHEN_BREADCRUMBS: Breadcrumb[] = [
  {
    label: 'Главная',
    link: '/',
  },
  {
    label: 'Услуги',
    link: '/uslugi/',
  },
];
